var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"timeline-section",class:{ 'timeline-section--active': _vm.isActive }},[_c('slide-down',{attrs:{"show":_vm.isActive},scopedSlots:_vm._u([{key:"toggle",fn:function(ref){
var isShown = ref.isShown;
return _vm._t("header",null,{"isShown":isShown})}},{key:"slide-body",fn:function(ref){
var isShown = ref.isShown;
return _vm._t("content",null,{"isShown":isShown})}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }